import { QueryBuilderTokenType } from '../../../../../../types';

export const removeTokenAtIndex = (
  tokens: QueryBuilderTokenType[],
  index: number
): QueryBuilderTokenType[] => {
  if (index < 0 || index >= tokens.length) {
    return tokens;
  }

  return [...tokens.slice(0, index), ...tokens.slice(index + 1)];
};
